import dynamic from 'next/dynamic';

import { Loader } from '@/components/base/Layout/Loader';
import { DatePickerRange } from '@/component/DateRange/DatePicker';

export const DatePicker = dynamic(
  () => import('./DatePicker').then((i) => i.DatePickerRange),
  {
    ssr: false,
    loading: () => (
      <div className="min-h-80">
        <Loader />
      </div>
    ),
  },
);

export const DatePickerModal = dynamic(
  () => import('./DatePicker').then((i) => i.DatePickerModal),
  {
    ssr: false,
    loading: () => null,
  },
);

export const InexactDaysButtons = dynamic(
  () => import('./InexactDaysButtons').then((i) => i.InexactDaysButtons),
  {
    ssr: false,
    loading: () => null,
  },
);
